// Mock data para proyectos ABP
const mockProjects = [
  {
    id: 1,
    title: 'Ecosistemas Marinos de Chile',
    description: 'Proyecto interdisciplinario para estudiar y crear conciencia sobre los ecosistemas marinos de la costa chilena, integrando ciencias naturales, matemáticas y lenguaje.',
    startDate: '2024-10-01',
    endDate: '2024-10-31',
    subjects: [
      {
        id: 1,
        name: 'Ciencias Naturales',
        content: ['Biodiversidad marina', 'Cadenas alimentarias', 'Impacto ambiental'],
        objectives: ['Identificar especies marinas locales', 'Analizar relaciones ecológicas']
      },
      {
        id: 2,
        name: 'Matemáticas',
        content: ['Estadísticas poblacionales', 'Gráficos y análisis de datos'],
        objectives: ['Crear gráficos de población de especies', 'Calcular porcentajes de conservación']
      },
      {
        id: 3,
        name: 'Lenguaje',
        content: ['Textos informativos', 'Presentaciones orales'],
        objectives: ['Redactar informe de investigación', 'Presentar hallazgos al curso']
      }
    ],
    courses: ['7° Básico A', '7° Básico B'],
    status: 'activo',
    progress: 65,
    teachers: [
      { id: 3, name: 'María José Rodríguez', subject: 'Ciencias Naturales' },
      { id: 6, name: 'Pedro Santander', subject: 'Matemáticas' },
      { id: 7, name: 'Laura Mendoza', subject: 'Lenguaje' }
    ],
    students: 58,
    deliverables: [
      { name: 'Investigación inicial', dueDate: '2024-10-08', status: 'completed' },
      { name: 'Análisis de datos', dueDate: '2024-10-15', status: 'in-progress' },
      { name: 'Informe final', dueDate: '2024-10-28', status: 'pending' }
    ],
    resources: [
      { name: 'Guía de especies marinas', type: 'pdf', url: '/resources/guia-especies.pdf' },
      { name: 'Video ecosistemas', type: 'video', url: '/resources/video-ecosistemas.mp4' }
    ],
    createdAt: '2024-09-25T10:00:00.000Z',
    updatedAt: '2024-10-15T14:30:00.000Z'
  },
  {
    id: 2,
    title: 'Historia Viva: Chile en el Siglo XX',
    description: 'Exploración de los acontecimientos más importantes del siglo XX en Chile a través de testimonios, documentos y análisis histórico.',
    startDate: '2024-11-01',
    endDate: '2024-11-30',
    subjects: [
      {
        id: 4,
        name: 'Historia',
        content: ['República Parlamentaria', 'Crisis de 1929', 'Gobiernos del siglo XX'],
        objectives: ['Analizar causas y consecuencias de eventos históricos', 'Desarrollar pensamiento crítico']
      },
      {
        id: 3,
        name: 'Lenguaje',
        content: ['Análisis de textos históricos', 'Escritura argumentativa'],
        objectives: ['Redactar ensayos históricos', 'Analizar fuentes primarias']
      },
      {
        id: 5,
        name: 'Arte',
        content: ['Arte chileno del siglo XX', 'Expresión visual de la historia'],
        objectives: ['Crear línea de tiempo visual', 'Analizar arte como reflejo social']
      }
    ],
    courses: ['1° Medio A', '1° Medio B'],
    status: 'planificado',
    progress: 0,
    teachers: [
      { id: 8, name: 'Roberto Fuentes', subject: 'Historia' },
      { id: 7, name: 'Laura Mendoza', subject: 'Lenguaje' },
      { id: 9, name: 'Carmen Silva', subject: 'Arte' }
    ],
    students: 54,
    deliverables: [
      { name: 'Línea de tiempo colaborativa', dueDate: '2024-11-10', status: 'pending' },
      { name: 'Análisis de testimonios', dueDate: '2024-11-18', status: 'pending' },
      { name: 'Exposición final', dueDate: '2024-11-29', status: 'pending' }
    ],
    resources: [],
    createdAt: '2024-10-01T09:15:00.000Z',
    updatedAt: '2024-10-01T09:15:00.000Z'
  },
  {
    id: 3,
    title: 'Emprendimiento Sostenible',
    description: 'Desarrollo de ideas de negocio sostenibles que aborden problemáticas locales, integrando matemáticas financieras, ciencias y tecnología.',
    startDate: '2024-09-15',
    endDate: '2024-12-15',
    subjects: [
      {
        id: 2,
        name: 'Matemáticas',
        content: ['Análisis financiero', 'Costos y presupuestos', 'Proyecciones'],
        objectives: ['Crear plan financiero', 'Calcular rentabilidad']
      },
      {
        id: 1,
        name: 'Ciencias Naturales',
        content: ['Sostenibilidad ambiental', 'Energías renovables'],
        objectives: ['Evaluar impacto ambiental', 'Proponer soluciones eco-friendly']
      },
      {
        id: 10,
        name: 'Tecnología',
        content: ['Herramientas digitales', 'Prototipado'],
        objectives: ['Crear prototipo digital', 'Usar herramientas de diseño']
      }
    ],
    courses: ['2° Medio A'],
    status: 'activo',
    progress: 85,
    teachers: [
      { id: 6, name: 'Pedro Santander', subject: 'Matemáticas' },
      { id: 3, name: 'María José Rodríguez', subject: 'Ciencias Naturales' },
      { id: 10, name: 'Diego Torres', subject: 'Tecnología' }
    ],
    students: 32,
    deliverables: [
      { name: 'Idea de negocio', dueDate: '2024-10-01', status: 'completed' },
      { name: 'Análisis de mercado', dueDate: '2024-10-30', status: 'completed' },
      { name: 'Prototipo', dueDate: '2024-11-30', status: 'in-progress' },
      { name: 'Pitch final', dueDate: '2024-12-10', status: 'pending' }
    ],
    resources: [
      { name: 'Plantilla plan de negocio', type: 'document', url: '/resources/plantilla-negocio.docx' },
      { name: 'Tutorial Figma', type: 'video', url: '/resources/tutorial-figma.mp4' }
    ],
    createdAt: '2024-09-01T08:30:00.000Z',
    updatedAt: '2024-10-20T16:45:00.000Z'
  }
];

// Simular delay de red
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

class ProjectService {
  constructor() {
    this.projects = [...mockProjects];
  }

  async getAllProjects(filters = {}) {
    await delay(500);

    try {
      let filteredProjects = [...this.projects];

      // Filtrar por curso si se especifica
      if (filters.course) {
        filteredProjects = filteredProjects.filter(project => 
          project.courses.includes(filters.course)
        );
      }

      // Filtrar por estado si se especifica
      if (filters.status) {
        filteredProjects = filteredProjects.filter(project => 
          project.status === filters.status
        );
      }

      // Filtrar por profesor si se especifica
      if (filters.teacherId) {
        filteredProjects = filteredProjects.filter(project => 
          project.teachers.some(teacher => teacher.id === filters.teacherId)
        );
      }

      // Filtrar por materia si se especifica
      if (filters.subject) {
        filteredProjects = filteredProjects.filter(project => 
          project.subjects.some(subject => subject.name === filters.subject)
        );
      }

      // Filtrar por rango de fechas
      if (filters.startDate && filters.endDate) {
        const start = new Date(filters.startDate);
        const end = new Date(filters.endDate);
        
        filteredProjects = filteredProjects.filter(project => {
          const projectStart = new Date(project.startDate);
          const projectEnd = new Date(project.endDate);
          
          return (projectStart >= start && projectStart <= end) ||
                 (projectEnd >= start && projectEnd <= end) ||
                 (projectStart <= start && projectEnd >= end);
        });
      }

      // Ordenar por fecha de inicio (más reciente primero)
      filteredProjects.sort((a, b) => new Date(b.startDate) - new Date(a.startDate));

      return {
        success: true,
        data: filteredProjects
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al obtener proyectos'
      };
    }
  }

  async getProjectById(id) {
    await delay(300);

    try {
      const project = this.projects.find(p => p.id === parseInt(id));
      
      if (!project) {
        return {
          success: false,
          message: 'Proyecto no encontrado'
        };
      }

      return {
        success: true,
        data: project
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al obtener proyecto'
      };
    }
  }

  async createProject(projectData) {
    await delay(800);

    try {
      const newProject = {
        id: Math.max(...this.projects.map(p => p.id)) + 1,
        ...projectData,
        status: projectData.status || 'planificado',
        progress: 0,
        students: 0,
        deliverables: [],
        resources: [],
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };

      this.projects.push(newProject);

      return {
        success: true,
        data: newProject,
        message: 'Proyecto creado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al crear proyecto'
      };
    }
  }

  async updateProject(id, projectData) {
    await delay(600);

    try {
      const projectIndex = this.projects.findIndex(p => p.id === parseInt(id));
      
      if (projectIndex === -1) {
        return {
          success: false,
          message: 'Proyecto no encontrado'
        };
      }

      const updatedProject = {
        ...this.projects[projectIndex],
        ...projectData,
        updatedAt: new Date().toISOString()
      };

      this.projects[projectIndex] = updatedProject;

      return {
        success: true,
        data: updatedProject,
        message: 'Proyecto actualizado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al actualizar proyecto'
      };
    }
  }

  async deleteProject(id) {
    await delay(400);

    try {
      const projectIndex = this.projects.findIndex(p => p.id === parseInt(id));
      
      if (projectIndex === -1) {
        return {
          success: false,
          message: 'Proyecto no encontrado'
        };
      }

      const deletedProject = this.projects.splice(projectIndex, 1)[0];

      return {
        success: true,
        data: deletedProject,
        message: 'Proyecto eliminado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al eliminar proyecto'
      };
    }
  }

  async updateProjectProgress(id, progress) {
    await delay(300);

    try {
      const projectIndex = this.projects.findIndex(p => p.id === parseInt(id));
      
      if (projectIndex === -1) {
        return {
          success: false,
          message: 'Proyecto no encontrado'
        };
      }

      this.projects[projectIndex].progress = Math.min(Math.max(progress, 0), 100);
      this.projects[projectIndex].updatedAt = new Date().toISOString();

      // Actualizar estado basado en el progreso
      if (progress === 100) {
        this.projects[projectIndex].status = 'completado';
      } else if (progress > 0) {
        this.projects[projectIndex].status = 'activo';
      }

      return {
        success: true,
        data: this.projects[projectIndex],
        message: 'Progreso actualizado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al actualizar progreso'
      };
    }
  }

  async addDeliverable(projectId, deliverable) {
    await delay(400);

    try {
      const projectIndex = this.projects.findIndex(p => p.id === parseInt(projectId));
      
      if (projectIndex === -1) {
        return {
          success: false,
          message: 'Proyecto no encontrado'
        };
      }

      const newDeliverable = {
        id: Date.now(),
        ...deliverable,
        status: deliverable.status || 'pending',
        createdAt: new Date().toISOString()
      };

      this.projects[projectIndex].deliverables.push(newDeliverable);
      this.projects[projectIndex].updatedAt = new Date().toISOString();

      return {
        success: true,
        data: newDeliverable,
        message: 'Entregable agregado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al agregar entregable'
      };
    }
  }

  async updateDeliverable(projectId, deliverableId, deliverableData) {
    await delay(400);

    try {
      const projectIndex = this.projects.findIndex(p => p.id === parseInt(projectId));
      
      if (projectIndex === -1) {
        return {
          success: false,
          message: 'Proyecto no encontrado'
        };
      }

      const deliverableIndex = this.projects[projectIndex].deliverables.findIndex(
        d => d.id === parseInt(deliverableId)
      );

      if (deliverableIndex === -1) {
        return {
          success: false,
          message: 'Entregable no encontrado'
        };
      }

      this.projects[projectIndex].deliverables[deliverableIndex] = {
        ...this.projects[projectIndex].deliverables[deliverableIndex],
        ...deliverableData,
        updatedAt: new Date().toISOString()
      };

      this.projects[projectIndex].updatedAt = new Date().toISOString();

      return {
        success: true,
        data: this.projects[projectIndex].deliverables[deliverableIndex],
        message: 'Entregable actualizado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al actualizar entregable'
      };
    }
  }

  async addResource(projectId, resource) {
    await delay(400);

    try {
      const projectIndex = this.projects.findIndex(p => p.id === parseInt(projectId));
      
      if (projectIndex === -1) {
        return {
          success: false,
          message: 'Proyecto no encontrado'
        };
      }

      const newResource = {
        id: Date.now(),
        ...resource,
        uploadedAt: new Date().toISOString()
      };

      this.projects[projectIndex].resources.push(newResource);
      this.projects[projectIndex].updatedAt = new Date().toISOString();

      return {
        success: true,
        data: newResource,
        message: 'Recurso agregado exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al agregar recurso'
      };
    }
  }

  async getProjectStats() {
    await delay(300);

    try {
      const total = this.projects.length;
      const active = this.projects.filter(p => p.status === 'activo').length;
      const planned = this.projects.filter(p => p.status === 'planificado').length;
      const completed = this.projects.filter(p => p.status === 'completado').length;
      const totalStudents = this.projects.reduce((sum, p) => sum + p.students, 0);
      const averageProgress = this.projects.reduce((sum, p) => sum + p.progress, 0) / total;

      return {
        success: true,
        data: {
          total,
          active,
          planned,
          completed,
          totalStudents,
          averageProgress: Math.round(averageProgress * 10) / 10
        }
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al obtener estadísticas'
      };
    }
  }

  async getProjectsByMonth(year = new Date().getFullYear()) {
    await delay(300);

    try {
      const monthlyData = new Array(12).fill(0);

      this.projects.forEach(project => {
        const startDate = new Date(project.startDate);
        if (startDate.getFullYear() === year) {
          monthlyData[startDate.getMonth()]++;
        }
      });

      return {
        success: true,
        data: monthlyData
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al obtener datos mensuales'
      };
    }
  }

  async updateProjectConfig(id, configData) {
    await delay(600);

    try {
      const projectIndex = this.projects.findIndex(p => p.id === parseInt(id));

      if (projectIndex === -1) {
        return {
          success: false,
          message: 'Proyecto no encontrado'
        };
      }

      // Actualizar proyecto con la configuración
      const updatedProject = {
        ...this.projects[projectIndex],
        title: configData.title,
        startDate: configData.startDate,
        endDate: configData.endDate,
        generalObjective: configData.generalObjective,
        expectedProduct: configData.expectedProduct,
        planningDeadline: configData.planningDeadline,
        thinkingSkill: configData.thinkingSkill,
        skills: configData.skills,
        parentInstructions: configData.parentInstructions,
        updatedAt: new Date().toISOString()
      };

      this.projects[projectIndex] = updatedProject;

      return {
        success: true,
        data: updatedProject,
        message: 'Configuración del proyecto actualizada exitosamente'
      };
    } catch (error) {
      return {
        success: false,
        message: 'Error al actualizar configuración del proyecto'
      };
    }
  }
}

export const projectService = new ProjectService();